export default "__VITE_ASSET__0darBy5S__"